import { render, staticRenderFns } from "./UrgentRule.vue?vue&type=template&id=494fa57a&scoped=true&"
import script from "./UrgentRule.vue?vue&type=script&lang=js&"
export * from "./UrgentRule.vue?vue&type=script&lang=js&"
import style0 from "./UrgentRule.vue?vue&type=style&index=0&id=494fa57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fa57a",
  null
  
)

export default component.exports